import { Helmet } from "react-helmet-async"
import { IHotel } from "../../../../Hotels"
import { HotelOtaMealPlans } from "../../../../HotelOtaMealPlans"
import { useOutletContext } from "../../../../router-utils"

export default function HotelMealPlansPage() {
	const { hotel, revalidate } = useOutletContext<{
		hotel: IHotel
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Meal Plans | Hotel</title>
			</Helmet>
			<HotelOtaMealPlans hotel={hotel} onChange={revalidate} />
		</>
	)
}
